(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kiara-diwali-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('kiara-diwali-popup');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var cursorEl = document.getElementById('lux-cursor');
    var cursorParent = cursorEl && cursorEl.parentNode;
    var cursorNextSibling = cursorEl && cursorEl.nextSibling;

    var copyButton = dialog.querySelector('.kiara-diwali-popup__copy');
    var codeElement = dialog.querySelector('.kiara-diwali-popup__code');
    var copyStatus = dialog.querySelector('.kiara-diwali-popup__copy-status');
    var copyFeedbackTimer = null;
    var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-carousel-slide]'));
    var indicators = Array.prototype.slice.call(dialog.querySelectorAll('[data-slide-to]'));
    var activeSlide = 0;
    var carouselTimer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showSlide(index) {
      if (!slides.length) return;
      activeSlide = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeSlide;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      indicators.forEach(function (indicator, indicatorIndex) {
        var isActive = indicatorIndex === activeSlide;
        indicator.classList.toggle('is-active', isActive);
        indicator.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function startCarousel() {
      if (reduceMotion || slides.length < 2) return;
      if (carouselTimer) window.clearInterval(carouselTimer);
      carouselTimer = window.setInterval(function () {
        showSlide(activeSlide + 1);
      }, 5000);
    }

    indicators.forEach(function (indicator, index) {
      indicator.addEventListener('click', function () {
        showSlide(index);
        startCarousel();
      });
    });

    function showCopyFeedback(message) {
      if (!copyStatus) return;
      copyStatus.textContent = message;
      copyStatus.classList.add('is-visible');
      if (copyFeedbackTimer) window.clearTimeout(copyFeedbackTimer);
      copyFeedbackTimer = window.setTimeout(function () {
        copyStatus.textContent = '';
        copyStatus.classList.remove('is-visible');
        if (copyButton) {
          copyButton.setAttribute('aria-label', 'Copy discount code');
          copyButton.setAttribute('title', 'Copy discount code');
          copyButton.removeAttribute('data-copied');
        }
      }, 2200);
    }

    function fallbackCopy(value) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {}
      textarea.remove();
      return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
    }

    if (copyButton && codeElement) {
      copyButton.addEventListener('click', function () {
        var value = codeElement.textContent.trim();
        var copyPromise;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          copyPromise = navigator.clipboard.writeText(value).catch(function () {
            return fallbackCopy(value);
          });
        } else {
          copyPromise = fallbackCopy(value);
        }

        copyPromise.then(function () {
          copyButton.setAttribute('aria-label', 'Discount code copied');
          copyButton.setAttribute('title', 'Discount code copied');
          copyButton.setAttribute('data-copied', 'true');
          showCopyFeedback('Discount code copied');
        }).catch(function () {
          copyButton.setAttribute('aria-label', 'Copy failed. Select the code to copy manually.');
          copyButton.setAttribute('title', 'Copy failed. Select the code to copy manually.');
          showCopyFeedback('Copy failed. Select the code to copy manually.');
        });
      });
    }


    window.setTimeout(function () {
      if (!dialog.isConnected || dialog.open || !window.kiaraCampaignIsActive || !window.kiaraCampaignIsActive()) return;
      dialog.showModal();
      startCarousel();
      if (cursorEl) {
        try {
          if (typeof cursorEl.hidePopover === 'function' && cursorEl.matches(':popover-open')) {
            cursorEl.hidePopover();
          }
          dialog.appendChild(cursorEl);
          if (typeof cursorEl.showPopover === 'function') cursorEl.showPopover();
        } catch (error) {}
      }
    }, Number(dialog.getAttribute('data-delay-ms')) || 5000);

    dialog.addEventListener('close', function () {
      if (carouselTimer) window.clearInterval(carouselTimer);
      if (!cursorEl || !cursorParent) return;
      try {
        if (typeof cursorEl.hidePopover === 'function' && cursorEl.matches(':popover-open')) {
          cursorEl.hidePopover();
        }
        cursorParent.insertBefore(cursorEl, cursorNextSibling && cursorNextSibling.parentNode === cursorParent ? cursorNextSibling : null);
        if (typeof cursorEl.showPopover === 'function') cursorEl.showPopover();
      } catch (error) {}
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
